// src/viqai/HeroLeadForm.jsx
// ─── Formulaire du hero vehicleiq.fr (§21-33) ───────────────────────────────
// Un vrai formulaire, pas un visuel : chaque champ part vers
// /api/public/demo-lead, qui écrit dans pro_leads, notifie par email et pose
// un évènement in-app. Six champs maximum — un hero n'est pas un formulaire
// administratif (§28).
//
// Même langage graphique que la page de connexion : fond graphite, champs
// à bord discret, bouton doré rectangulaire arrondi, aucune capsule.

import { useState } from "react";
import "./viqai-dark.css";

const NEEDS = [
  ["gain_temps", "Gagner du temps"],
  ["analyse_vehicules", "Analyser mes véhicules"],
  ["opportunites", "Trouver des opportunités"],
  ["structurer_dossiers", "Structurer mes dossiers"],
  ["piloter_equipe", "Piloter mon équipe"],
  ["autre", "Autre"],
];

export default function HeroLeadForm({ apiUrl, onPrivacy }) {
  const [f, setF] = useState({ name: "", company: "", email: "", phone: "", vehicle_volume: "", primary_need: "", website: "" });
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [error, setError] = useState(null);
  const set = (k) => (e) => setF(x => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (state === "sending") return;
    setError(null); setState("sending");
    try {
      const r = await fetch(`${apiUrl}/api/public/demo-lead`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...f, page: typeof window !== "undefined" ? window.location.pathname : "/" }),
      });
      const j = await r.json().catch(() => ({}));
      if (r.ok && j.success) setState("done");
      else { setError(j.error || "Votre demande n'a pas pu être envoyée."); setState("error"); }
    } catch (err) {
      setError("Connexion impossible. Réessayez dans un instant."); setState("error");
    }
  };

  if (state === "done") {
    return (
      <div className="viq-hero-form viq-dark" role="status">
        <div className="viq-hero-form-done">
          <div className="viq-hero-form-title">Merci.</div>
          <p>Votre demande a bien été transmise.</p>
          <p className="viq-hero-form-muted">Notre équipe vous recontacte rapidement.</p>
        </div>
      </div>
    );
  }

  return (
    <form className="viq-hero-form viq-dark" onSubmit={submit} noValidate>
      <div className="viq-hero-form-title">Parlez-nous de votre activité</div>
      <div className="viq-hero-form-muted">Nous vous montrons VIQ.AI sur vos propres véhicules.</div>

      {/* Honeypot : invisible et hors tabulation. Un humain ne le remplit
          jamais ; un script le remplit systématiquement. */}
      <input type="text" name="website" value={f.website} onChange={set("website")}
        tabIndex={-1} autoComplete="off" aria-hidden="true"
        style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} />

      <label className="viq-hero-field">
        <span>Nom et prénom</span>
        <input required value={f.name} onChange={set("name")} autoComplete="name" placeholder="Jean Martin" />
      </label>
      <label className="viq-hero-field">
        <span>Entreprise</span>
        <input value={f.company} onChange={set("company")} autoComplete="organization" placeholder="Auto Prestige" />
      </label>
      <label className="viq-hero-field">
        <span>Email professionnel</span>
        <input required type="email" value={f.email} onChange={set("email")} autoComplete="email" placeholder="jean@autoprestige.fr" />
      </label>
      <div className="viq-hero-row">
        <label className="viq-hero-field">
          <span>Téléphone</span>
          <input type="tel" value={f.phone} onChange={set("phone")} autoComplete="tel" placeholder="06 12 34 56 78" />
        </label>
        <label className="viq-hero-field">
          <span>VO / mois</span>
          <input type="number" min="0" value={f.vehicle_volume} onChange={set("vehicle_volume")} placeholder="20" />
        </label>
      </div>
      <label className="viq-hero-field">
        <span>Votre besoin principal</span>
        <select value={f.primary_need} onChange={set("primary_need")}>
          <option value="">Choisir…</option>
          {NEEDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </label>

      {error && <div className="viq-hero-error" role="alert">{error}</div>}

      <button type="submit" className="viq-btn-primary viq-hero-submit" disabled={state === "sending"}>
        {state === "sending" ? "Envoi…" : "Être recontacté"}
      </button>

      {/* §83 — Consentement explicite, lien vers la politique existante. */}
      <div className="viq-hero-consent">
        En envoyant ce formulaire, vous acceptez d'être recontacté par VehicleIQ.{" "}
        <button type="button" onClick={() => onPrivacy && onPrivacy("privacy")}>Confidentialité</button>
      </div>
    </form>
  );
}
